import { BannerExpand } from '@trevor/ui-components';
import React from 'react';
import { userAction } from '@/util/helpers/ajax-helpers';
import { useToggle } from '@/hooks';

export const LearMoreBanner = () => {
  const [expanded, toggleExpanded] = useToggle(false, true);

  const handleExpand = () => {
    if (!expanded) {
      userAction('embed-dashboards-sidebar-share-with-others-tab', {
        action: 'learn-more-about-permissions',
      });
    }
    toggleExpanded();
  };

  return (
    <BannerExpand
      label="Learn about permissions"
      severity="info"
      width="100%"
      expanded={expanded}
      onExpand={handleExpand}
    >
      Guests can only access the dashboards they have been invited to.
      <br />
      <br />
      They can:
      <ul>
        <li>use dashboard filters.</li>
        <li>schedule dashboard delivery via email/slack.</li>
      </ul>
      <br />
      They cannot:
      <ul>
        <li>edit dashboards.</li>
        <li>view any underlying queries.</li>
        <li>invite other guests.</li>
      </ul>
    </BannerExpand>
  );
};
